import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Network/IP_Configuration/SuccessBox';
import IPConfigTable from 'components/Web_User_Interface/1080p_Series/Network/IP_Configuration/ipConfigTable';
import CertCards from 'components/Web_User_Interface/1080p_Series/Network/IP_Configuration/CertCards';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  IPConfigTable,
  CertCards,
  BreadCrumbs,
  SEOHelmet,
  React
};